/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function WorkExperience() {
    const tableName = 'WorkExperience';
    const secondTableName = 'SpouseWorkExperience';

    const [dataList, setData] = useState<any>();
    const [spouseWorkExp, setSpouseWorkExp] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        setSpouseWorkExp(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
        api.tableInput.fetchCandidateInput(setSpouseWorkExp, secondTableName, candidate_id);
    }, [candidate_id]);

    return (
        <>
            <div>
                <S.Title>Applicant</S.Title>
                {dataList?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.BoxPart1>
                            <h4>Work Permit</h4>

                            <S.Value> {data?.work_permit}</S.Value>
                            <S.BoxPart2>
                                <h4>Profession</h4>
                                <h4>Current</h4>
                                <S.Value>
                                    {data?.profession_aus + ' / ' + data?.profession_can}
                                </S.Value>

                                <S.Value>{data?.current ? 'Yes' : 'No'}</S.Value>
                                <h4>Start Date</h4>
                                <h4>End Date</h4>
                                <S.Value>{data?.start?.substring(4, 17)}</S.Value>
                                <S.Value>{data?.end?.substring(4, 17)}</S.Value>
                                <h4>Country</h4>
                                <h4> Region </h4>
                                <S.Value>{data?.country}</S.Value>
                                <S.Value>{data?.region}</S.Value>
                            </S.BoxPart2>
                        </S.BoxPart1>
                    </span>
                ))}
            </div>
            <div>
                <S.Title>Spouse</S.Title>
                {spouseWorkExp?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.BoxPart1>
                            <h4>Work Permit</h4>

                            <S.Value> {data?.work_permit}</S.Value>
                            <S.BoxPart2>
                                <h4>Profession</h4>
                                <h4>Current</h4>
                                <S.Value>{data?.profession}</S.Value>
                                <S.Value>{data?.current ? 'Yes' : 'No'}</S.Value>
                                <h4>Start Date</h4>
                                <h4>End Date</h4>
                                <S.Value>{data?.start.substring(4, 17)}</S.Value>
                                <S.Value>{data?.end?.substring(4, 17)}</S.Value>
                                <h4>Country</h4>
                                <h4> Region </h4>
                                <S.Value>{data?.country}</S.Value>
                                <S.Value>{data?.region}</S.Value>
                            </S.BoxPart2>
                        </S.BoxPart1>
                    </span>
                ))}
            </div>
        </>
    );
}
